import { httpError } from 'store/httpError.js'
import * as util from 'lib/util.js'

export default {
    getFoldersForKbrid(context, payload){
        PubSub.publish("requestout",null);
        fetch(context.state.kb_rest_server + "/kb/jrest/getCollectionTree", {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: "externalId="+ encodeURIComponent(payload.externalId) +"&langCode="+ encodeURIComponent(payload.langCode)
        }) 
        .then(function(response) {
            if (!response.ok) {
                httpError(response, context);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            context.commit("setState", {property:  "folder_tree" ,  value: data });
        })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            });
    },
    getFilesInFolder(context, payload){
        PubSub.publish("requestout",null);
        fetch(context.state.kb_rest_server + "/kb/jrest/getFilesInFolder", {
            method: 'post',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: "collectionId="+ encodeURIComponent(payload) 
        }) 
        .then(function(response) {
            if (!response.ok) {
                httpError(response, context);
                throw Error();  //to bail out of promise chain
            }
            return response;
        }.bind(this))
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            context.commit("setState", {property:  "folder_files" ,  value: data });
        })
        .catch(function(error) {
            })
        .finally(function(){
                PubSub.publish("requestin",null);
            });
    },

};




